module.exports = __webpack_public_path__ + "img/cmgp.6d74f167.png";